export default __webpack_public_path__ + "static/media/gastroschool.c0619a7a.png";